import { css } from "styled-components";

export const responsiveWidth = css`
  margin: 0 auto;

  @media (min-width: 1921px) {
    max-width: 1108px;
  }

  @media (min-width: 1351px) and (max-width: 1920px) {
    max-width: 1075px;
  }

  @media (min-width: 1025px) and (max-width: 1350px) {
    max-width: 925px;
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    padding-left: 30px;
    padding-right: 30px;
  }

  @media (min-width: 568px) and (max-width: 767px) {
    padding-left: 25px;
    padding-right: 25px;
  }

  @media (max-width: 567px) {
    padding-left: 15px;
    padding-right: 15px;
  }
`;
